import PropTypes from 'prop-types';
import device from '#props/device';
import settings from '#props/devices/settings';
import match from '#props/devices/match';

export default {
  classes: PropTypes.object,
  match,
  device: PropTypes.shape({
    ...device,
    settings: PropTypes.arrayOf(PropTypes.shape(settings)),
    power: PropTypes.shape({
      details: PropTypes.string,
      identifier: PropTypes.string,
      timestamp: PropTypes.string
    })
  }),
  dispatch: PropTypes.func,
  fetchDevice: PropTypes.func,
  fetchEvents: PropTypes.func,
  fetchLocations: PropTypes.func,
  measurements: PropTypes.arrayOf(PropTypes.shape({
    cd: PropTypes.number,
    h: PropTypes.number,
    hOut: PropTypes.number,
    t: PropTypes.number,
    tOut: PropTypes.number,
    timestamp: PropTypes.string
  }))
};
